import type { BetSlipState } from '../types';

const attemptBetPlacement = (state: BetSlipState): BetSlipState => ({
  ...state,
  errorCode: undefined,
  isLocked: true
});

export default attemptBetPlacement;
